import React, { useState, useContext, useEffect } from "react";
import { GetHook, postEndpoint, putEndpoint } from "../../api/api";
import {
  USER_URL,
  KPI_URL,
  PERSPECTIVE_URL,
  SCORECARD_URL,
  USER_REVIEWERS_URL,
  USER_REVIEW_URL,
} from "../../api/urls";
import { Formik, Field } from "formik";
import { DropDown } from "../../ui/DropDown";
import { parseDropdown } from "../../utils/parseDropdown";
import { Button } from "../../ui/Button";
import { TitleText } from "../../ui/Text";
import { RadioInput } from "../../ui/RadioInput";
import { get } from "../../utils/get";
import { ReviewQuestions } from "./modal360/ReviewQuestions";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { QuestionAnswer } from "@material-ui/icons";
import { log } from "console";
export const Modal360 = ({ closeModal}) => {
  const auth = useContext(AuthContext);
  const userId = get(auth, "authState.user.id");
  const [step, setStep] = useState(0);
  const [postRes, postReviewResults] = postEndpoint();
  const [putRes, putReviewResults] = putEndpoint();
  const { data, error }: any = GetHook(
    `${USER_REVIEWERS_URL}?user_id=${userId}`
  );
  const userData = parseDropdown(data);
  useEffect(() => {
    if (get(postRes, "error")) {
      toast.error(get(postRes, "data.message"));
    } else if (
      !get(postRes, "error") &&
      get(postRes, "data") &&
      get(postRes, "data")
    ) {
      toast.success("Review added successfully");
      closeModal();
    }
    return () => {
      // cleanup
    };
  }, [postRes]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message);
    }
    return () => {};
  }, [error]);
  const handleSubmit = (values) => {
    let { user, ...questionAnwer } = values;
    questionAnwer = Object.entries(questionAnwer);
    const allQuestions = questionAnwer
      .map((question) => {
        return !get(question, "[0]", "").includes("comment") && question;
      })
      .filter(Boolean);
    const questionsAndComments = allQuestions.map((question) => {
      const aqComment = get(values, `${question[0]}_comment`);
      return [...question, aqComment];
    });  
      
    questionsAndComments.map((qna) => {
      const answer = JSON.parse(get(qna, "[1]"))
      const payload = {
        source_user_id: userId,
        target_user_id: get(values, "user.value"),
        kpi_question_id: get(qna, "[0]"),
        kpi_question_answer_id: answer.answerId,
        points: answer.points,
        notes: get(qna, "[2]"),
      };
      postReviewResults(USER_REVIEW_URL, payload);
    });
      const payload = {
        is_reviewed: true,
        reviewer_user_id: userId,
        reviewed_user_id: get(values, "user.value"),
      };
      putReviewResults(USER_REVIEWERS_URL, payload);
  };
  return (
    <Formik
      initialValues={{ user: { label: "", value: "" } }}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, values }) => (
        <>
          {step === 0 && (
            <div style={{ width: "31em" }}>
              <TitleText style={{ marginBottom: "2em", marginTop: "-2em" }}>
                Select user to rate
              </TitleText>
              <Field
                name="user"
                component={DropDown}
                options={userData}
                isBordered
              />
            </div>
          )}
          {step === 1 && <ReviewQuestions user={values.user} />}
          <div
            style={{
              marginTop: "2em",
              padding: "0.5em 2em",
              float: "right",
            }}
          >
            {step === 1 && (
              <Button
                text="Back"
                backgroundColor="#fff"
                color="#214160"
                onClick={() => setStep(step - 1)}
              />
            )}
            <Button
              text={step === 0 ? "Next" : "Finish"}
              onClick={() => (step === 1 ? handleSubmit() : setStep(step + 1))}
            />     
          </div>
        </>
      )}
    </Formik>
  );
};
